import { useCallback, useMemo } from 'react';

import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ADD_CARD } from '@/components/organisms/Modals/ModalConductor';
import { Button } from '@/components/ui/button';
import { useBilling } from '@/modules/billing/hooks/useBilling';
import { pushModal } from '@/redux/modals/actions';

import { PaymentMethodsTable } from './PaymentMethodsTable';

export const PaymentMethodsFieldset = () => {
  const { t } = useTranslation();
  const { paymentMethods } = useBilling();
  const dispatch = useDispatch();

  const canAddMoreCards = useMemo(() => {
    const length = paymentMethods?.length ?? 0;
    return length < 3;
  }, [paymentMethods]);

  const handleAddCard = useCallback(() => {
    dispatch(pushModal(ADD_CARD, {}));
  }, [dispatch]);

  return (
    <div className="flex flex-col gap-2">
      <h2 className="px-1.5 text-sm font-medium text-foreground-muted">
        {t('billing.payment_title')}
      </h2>
      <div className="flex flex-col gap-6 rounded-lg border border-border bg-background p-6">
        <p className="text-sm text-foreground-muted">{t('billing.payment_subtitle')}</p>
        <PaymentMethodsTable />
        <div className="flex justify-end">
          <Button type="button" disabled={!canAddMoreCards} onClick={handleAddCard}>
            <PlusIcon className="size-4" />
            {t('billing.payment_add_card')}
          </Button>
        </div>
      </div>
    </div>
  );
};
